// RICORDA: Se vuoi passare da LIVE a SANDBOX devi cambiare l'enviroment anche nel back-end (create and approve)
const paypalConfig = { 
  "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
  currency: "EUR",
  intent: "capture"
};

export default paypalConfig;